"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNativeWeb = require("react-native-web");

var _AaPassengerRoomSelection = _interopRequireDefault(require("./AaPassengerRoomSelection.styles"));

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var PopUpContainer = function PopUpContainer(props) {
  var isMobile = props.isMobile,
      children = props.children,
      openModal = props.openModal,
      onClose = props.onClose,
      passengerSelectionID = props.passengerSelectionID,
      leftAligned = props.leftAligned;

  if (isMobile) {
    return /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaModal, {
      isVisible: openModal,
      wrapperStyle: _AaPassengerRoomSelection["default"].modalPopupContainer,
      backdropColor: "black",
      backdropOpacity: "0.5",
      isClosingOnBackdropPress: true,
      onClose: onClose
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.ScrollView, {
      style: _AaPassengerRoomSelection["default"].modalPopup
    }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
      style: _AaPassengerRoomSelection["default"].modalContainer
    }, children)));
  }

  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: _AaPassengerRoomSelection["default"].popupContainer
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: [_AaPassengerRoomSelection["default"].popup, leftAligned && _AaPassengerRoomSelection["default"].popupLeftAligned],
    nativeID: "".concat(passengerSelectionID)
  }, children));
};

var _default = PopUpContainer;
exports["default"] = _default;